<div class="px-3 py-2">
	<h4 align="center">DE CIFRIS HACKATHON 2019</h4>
	<p>I team Cifris Chain e Gare e Divulgazione della De Componendis 
		Cifris hanno organizzato una Hackathon congiuntamente con tre realtà di ricerca.
	</p>
	<a href="../../../../assets/eventi/2019/Hackaton/DeCifris_Hackathon_2019.pdf">LOCANDINA</a>
	<br>
	<b>I vincitori sono:</b><br>
	<ul>
		<li>
			<b>Team 1 - Trento:</b>
			<p>Veronica Cristiano, Andrea Flamini, Lorenzo Romagnoni, Sara Tizianel.</p>
		</li>
		<li>
			<b>Team 4 - Milano:</b>
			<p>Daniele Giacomo Vittorio Albricci, Mirko Mannino, Matteo Negri, Lorenzo Riva.</p>
		</li>
	</ul>
	<h4>EVENTO</h4>
	<p>Il giorno 26 settembre 2019 si è svolto l'evento come segue:</p>
	<ul>
		<li><p>09.00: Registrazione partecipanti;</p></li>
		<li><p>09.30: Opening session e inizio Hackathon;</p></li>
		<li><p>16.30: Consegna software sviluppati e inizio valutazione;</p></li>
		<li><p>17.30: Annuncio vincitori.</p></li>
	</ul>
	<br>
	<h6>DOVE</h6>
	<p>L'Hackathon si è tenuto simultaneamente in due sedi:</p>
	<ul>
		<li>Department of Computer Science UniMi - Aula Magna A. Bertoni, via Celoria 18, Milano.</li>
		<li>Department of Mathematics UniTn e FBK - Sala Consiglio FBK, via Sommarive 18, Povo, Trento.</li>
	</ul>
	<br>
	<h6>COME PARTECIPARE</h6>
	<p>Per partecipare alla Hackathon bisognava:</p>
	<ul>
		<li> <p>registrarsi usando l'apposito form, ora chiuso;</p></li>
		<li> <p>presentarsi non oltre le 9.30 presso la sede prescelta; </p></li>
		<li> <p>ascoltare la Opening Session (trasmessa in videoconferenza in tutte le sedi), in cui
				sono stati presentati i due progetti da realizzare, all'interno del tema generale della Hackathon:
				<b> Food, Health & Sustainability</b>, con inclusi aspetti <b>crittografici</b>; </p></li>
		<li> <p>aderire a uno dei team che si formano nella sede, in base al progetto preferito;</p></li>
		<li> <p>scrivere assieme al proprio team uno smart contract in Solidity che cerchi di realizzare
				il progetto il meglio possibile, consegnandolo per le 16.30;</p></li>
		<li> <p>attendere il responso dell'<b>Hackaton Jury</b>: prof. Massimiliano Sala, 
			prof. Andrea Visconti e prof. Ivan Visconti, coadiuvati da esperti programmatori.</p></li>
	</ul>
</div>